import { gql } from "@apollo/client";

export const getTermsAndConditionsByOfferAdditionalQuery = gql` query GetTermsAndConditionsByOffer($id: String!) {
  getTermsAndConditions(id: $id) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  },
    getTermsOffer(id: $id) {
    product {
      name
      code
      brand { code name logoUrl }
    }
  }
}
`